var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[(_vm.itemTitle != '')?_c('div',{staticClass:"fieldsetTitle"},[_vm._v(" "+_vm._s(_vm.$g(`${_vm.itemTitle}`))+" ")]):_vm._e(),_c('div',{staticClass:"fieldsetBody"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }